import React from 'react';
import cn from 'clsx';
import styles from './index.module.scss';
import Button, { ButtonProps } from '@components-clean/core/button';

const CardAction = ({ className, ...props }: ButtonProps) => {
    return <Button className={cn(styles.button, className)} {...props} />;
};

export default CardAction;
